import React from "react";
import { MessageCircle } from "lucide-react";
import { HOME } from "@/constants/testIds";

export default function FloatingWhatsapp({ number = "918824207033" }) {
  return (
    <a
      href={`https://wa.me/${number}`}
      target="_blank"
      rel="noreferrer"
      data-testid={HOME.floatingWhatsapp}
      className="fixed z-40 bottom-5 right-5 group inline-flex items-center gap-3 h-14 pl-4 pr-5 rounded-full bg-[#25D366] text-white shadow-high hover:-translate-y-0.5 transition-transform"
      aria-label="Chat with Be Hire Ready on WhatsApp"
    >
      <MessageCircle size={22} strokeWidth={2.2} />
      <span className="max-w-0 group-hover:max-w-[220px] overflow-hidden whitespace-nowrap transition-[max-width] duration-500 text-sm font-medium">
        Chat with Be Hire Ready
      </span>
    </a>
  );
}
